import { render, staticRenderFns } from "./TestWrapper.vue?vue&type=template&id=003d34a9"
import script from "./TestWrapper.vue?vue&type=script&lang=js"
export * from "./TestWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports